import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaMoneyCheckAlt,
  FaHistory,
  FaCreditCard,
  FaSignOutAlt,
  FaBars,
} from "react-icons/fa";

export default function Navbar() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const sidebarWidth = 200; // desktop sidebar width
  const mobileNavHeight = 60; // mobile bottom navbar height

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("userRole");
    navigate("/");
    window.location.reload();
  };

  // Adjust page offsets dynamically
  const adjustPageOffset = () => {
    const body = document.getElementById("root");
    if (!body) return;
    if (isMobile) {
      body.style.marginLeft = "0px";
      body.style.paddingBottom = `${mobileNavHeight}px`;
    } else {
      body.style.marginLeft = isSidebarOpen ? `${sidebarWidth}px` : "0px";
      body.style.paddingBottom = "0px";
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    adjustPageOffset();
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile, isSidebarOpen]);

  useEffect(() => {
    adjustPageOffset();
  }, [isMobile, isSidebarOpen]);

  const navLinkStyle = (isActive) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "0.5rem 0.8rem",
    borderRadius: "6px",
    fontWeight: 600,
    color: isActive ? "#fff" : "#1e1eaa",
    backgroundColor: isActive ? "#0080ff" : "transparent",
    textDecoration: "none",
    marginBottom: "0.6rem",
    boxShadow: isActive ? "0 2px 6px rgba(0,128,255,0.4)" : "none",
    flexDirection: isMobile ? "column" : "row",
    fontSize: isMobile ? "0.75rem" : "0.9rem",
  });

  const navItems = (
    <>
      <li>
        <NavLink to="/dashboard" style={({ isActive }) => navLinkStyle(isActive)} end>
          <FaHome />
          <span>Dashboard</span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/withdraw" style={({ isActive }) => navLinkStyle(isActive)}>
          <FaMoneyCheckAlt />
          <span>Withdraw</span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/history" style={({ isActive }) => navLinkStyle(isActive)}>
          <FaHistory />
          <span>History</span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/my-card" style={({ isActive }) => navLinkStyle(isActive)}>
          <FaCreditCard />
          <span>My Card</span>
        </NavLink>
      </li>
    </>
  );

  if (isMobile) {
    return (
      <nav
        style={{
          display: "flex",
          justifyContent: "space-around",
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          height: mobileNavHeight,
          backgroundColor: "#fff",
          borderTop: "1px solid #ddd",
          padding: "0.4rem 0",
          zIndex: 1000,
        }}
      >
        <ul
          style={{
            listStyle: "none",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            width: "100%",
            margin: 0,
            padding: 0,
          }}
        >
          {navItems}
          <li>
            <button
              onClick={handleLogout}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2px",
                fontSize: "0.75rem",
                border: "none",
                background: "none",
                color: "red",
                cursor: "pointer",
              }}
            >
              <FaSignOutAlt />
              <span>Logout</span>
            </button>
          </li>
        </ul>
      </nav>
    );
  }

  return (
    <>
      <button
        onClick={() => setIsSidebarOpen((prev) => !prev)}
        style={{
          position: "fixed",
          top: "1rem",
          left: "1rem",
          background: "none",
          border: "none",
          fontSize: "1.4rem",
          zIndex: 1100,
          cursor: "pointer",
          color: "#1e1eaa",
        }}
      >
        <FaBars />
      </button>
      {isSidebarOpen && (
        <nav
          style={{
            width: sidebarWidth,
            height: "95vh",
            position: "fixed",
            top: 0,
            left: 0,
            padding: "1.5rem 1rem",
            boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
        >
          <div>
            <h2
              style={{
                fontWeight: 700,
                fontSize: "1.2rem",
                marginBottom: "1.5rem",
                color: "#1e1eaa",
              }}
            >
              QuantumCashout
            </h2>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>{navItems}</ul>
          </div>
          <button
            onClick={handleLogout}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "0.5rem 0.8rem",
              backgroundColor: "#1e1eaa",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            <FaSignOutAlt /> Logout
          </button>
        </nav>
      )}
    </>
  );
}
